// import React from 'react';
// import GoogleSignin from '../img/web_dark_rd_ctn@1x.png';
// import { auth } from '../firebase';
// import { useAuthState } from 'react-firebase-hooks/auth';
// import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

// const NavBar = () => {
//     const [user] = useAuthState(auth); // (auth)[0]

//     const googleSignIn = () => {
//         const provider = new GoogleAuthProvider();
//         signInWithPopup(auth, provider);
//     };
//     const signOut = () => {
//         // setUser(false);
//         auth.signOut();
//     };

//     return (
//         <nav className='NavBar'>
//             <h1> React Chatter</h1>
//             {user ? (
//                 <button onClick={signOut} className='signOut' type='button'>
//                     Sign signOut
//                 </button>
//             ) : (
//                 <button className='signIn'>
//                     <img
//                         onClick={googleSignIn}
//                         src={GoogleSignin}
//                         alt='sign in with google'
//                         type='button'
//                     />
//                 </button>
//             )}
//         </nav>
//     );
// };

// export default NavBar;
// import React, { useState } from 'react';
// import GoogleSignin from '../img/web_dark_rd_ctn@1x.png';
import React from 'react';
import GoogleSignInCircleLogo from '../img/Google_circle_logo.svg';
import { auth } from '../firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import './Navbar.css';

const Navbar = () => {
    // const [user, setUser] = useState(false);
    const [user] = useAuthState(auth);

    const googleSignIn = () => {
        // setUser(true);
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider);
    };
    const signOut = () => {
        // setUser(false);
        auth.signOut();
    };

    return (
        <nav className='nav-bar'>
            <h1>Chatter</h1>
            {user ? (
                <button onClick={signOut} className='sign-out' type='button'>
                    Sign Out
                </button>
            ) : (
                <button className='sign-in'>
                    <img
                        onClick={googleSignIn}
                        src={GoogleSignInCircleLogo}
                        alt='sign in with google'
                        type='button'
                    />
                </button>
            )}
        </nav>
    );
};

export default Navbar;
